const groupCls = "_275g1r01ur";
const itemCls = "_275idt6jd4";

export { groupCls, itemCls };
import "./atom.group.style.linaria.module.css";
//# sourceMappingURL=atom.group.style.js.map
